import { render, staticRenderFns } from "./SmsBody.vue?vue&type=template&id=1505439b&scoped=true"
import script from "./SmsBody.vue?vue&type=script&lang=js"
export * from "./SmsBody.vue?vue&type=script&lang=js"
import style0 from "./SmsBody.vue?vue&type=style&index=0&id=1505439b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1505439b",
  null
  
)

export default component.exports